module.exports = __webpack_public_path__ + "static/APPAREL1-71c1ccf8ba7731911542a76888a1bfd0.png";